/** The product's right vocabulary. Ported from Entities/Identity/AppRole.cs. */
export const Rights = {
    All: '*',
    View: 'VIEW',
    Create: 'CREATE',
    Update: 'UPDATE',
    Delete: 'DELETE',
    Export: 'EXPORT',
    Import: 'IMPORT',
    /** Approve or reject a completed interview. */
    Review: 'REVIEW',
    /** Edit criteria, questions, templates, proctoring profiles, branding, providers. */
    Configure: 'CONFIGURE',
    /** Manage users, roles, API keys and webhooks. */
    ManageUsers: 'MANAGE_USERS',
    /** View a candidate's recording. Separated from View because it is the most sensitive read. */
    ViewRecording: 'VIEW_RECORDING'
} as const;

export const ALL_RIGHTS: readonly string[] = [
    Rights.View, Rights.Create, Rights.Update, Rights.Delete, Rights.Export, Rights.Import,
    Rights.Review, Rights.Configure, Rights.ManageUsers, Rights.ViewRecording
];

export const RoleCodes = {
    Administrator: 'ADMIN',
    Recruiter: 'RECRUITER',
    Reviewer: 'REVIEWER'
} as const;

export const ApiScopes = {
    CandidatesWrite: 'candidates:write',
    CandidatesRead: 'candidates:read',
    InterviewsWrite: 'interviews:write',
    InterviewsRead: 'interviews:read',
    TemplatesRead: 'templates:read'
} as const;

export const ALL_API_SCOPES: readonly string[] = Object.values(ApiScopes);

/** Rights are stored uppercase in a CSV column; blanks and duplicates are ignored. */
export const parseRights = (csv: string | null | undefined): string[] =>
    [...new Set((csv ?? '').split(',').map((r) => r.trim().toUpperCase()).filter(Boolean))];

/** Scopes are stored lowercase. */
export const parseScopes = (csv: string | null | undefined): string[] =>
    [...new Set((csv ?? '').split(',').map((s) => s.trim().toLowerCase()).filter(Boolean))];

/** A single '*' grants everything. */
export const hasRight = (rights: readonly string[], required: string): boolean =>
    rights.includes(Rights.All) || rights.includes((required ?? '').toUpperCase());

export const hasScope = (scopes: readonly string[], required: string): boolean =>
    scopes.includes((required ?? '').toLowerCase());
